import { Organization } from "@bluefalcon/users-management-client-fetch";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { organizationService } from "../../services";
import { Box, Heading, Flex, Text, Button, useDisclosure } from "@chakra-ui/react";
import { LoadingSpinner } from "@bluefalcon/components-package";
import { toast } from "../../utils/toast.utils";
import { OrganizationMembershipsTable } from "../../components/organization-memberships/organization-memberships.comp";
import { CreateOrgInviteCodeModal } from "../../modals/create-org-invite-code.modal";
import { ConfirmModal } from "../../modals/confirm-modal.modal";


export function OrganizationDetails() {
    const { organizationId } = useParams();
    const navigate = useNavigate();
    const [organization, setOrganization] = useState<Organization>();
    const [isLoading, setIsLoading] = useState(false);
    const codeModalControl = useDisclosure();
    const confirmModalControl = useDisclosure();

    const getOrganizationById = async () => {
        if (!organizationId) {
            navigate('/');
            return;
        }
        try {
            setIsLoading(true);
            const foundOrganization = await organizationService.getOrganizationById(organizationId);
            setOrganization(foundOrganization);
        } catch (e: any) {
            toast('No org found', 'error');
            navigate('/');
        } finally {
            setIsLoading(false);
        }
    };

    const onCreateCode = async (code: string) => {
        await organizationService.createOrgInviteCode(organizationId!, code);
        onChangeMemberships();
    };

    const removeCode = async () => {
        await organizationService.deleteOrgInviteCode(organizationId!);
        confirmModalControl.onClose();
        onChangeMemberships();
    };

    const onChangeMemberships = () => {
        getOrganizationById();
    };

    useEffect(() => {
        getOrganizationById();
    }, []);

    if (isLoading) {
        return <LoadingSpinner />
    }

    if (!organization) {
        return <div></div>
    }

    return (
        <Box p={4}>
            <Flex>
                <Heading as={'h1'}>{organization.name}</Heading>
            </Flex>
            <Box
                mt={5}
                borderWidth="1px"
                borderRadius="lg"
                p={6}
                boxShadow="md"
                mb={6}
                bg="white"
            >
                <Flex mb={4}>
                    <Text fontWeight="bold" mr={2}>
                        ID:
                    </Text>
                    <Text>{organization.id}</Text>
                </Flex>
                <Flex mb={4}>
                    <Text fontWeight="bold" mr={2}>
                        Name:
                    </Text>
                    <Text>{organization.name}</Text>
                </Flex>
            </Box>
            <Box mt={10}>
                <Heading size="md">Invite Codes</Heading>
                {organization.code?.code ? (
                    <Flex mt={4} p={2} borderWidth={1} borderRadius="md" align="center">
                        <Text mr={3} fontWeight="bold">Code:</Text>
                        <Text mr={3}>{organization.code.code}</Text>
                        <Button onClick={confirmModalControl.onOpen} size={'xs'} colorScheme="danger">{"Remove"}</Button>
                    </Flex>
                ) : (
                    <Button onClick={codeModalControl.onOpen} mt={4} colorScheme="warn">Make Code</Button>
                )}
            </Box>
            <Box mt={10}>
                <Heading size={'md'}>Memberships</Heading>
                <OrganizationMembershipsTable onChange={onChangeMemberships} organization={organization} memberships={organization.memberships ?? []} />
            </Box>
            <CreateOrgInviteCodeModal
                closeModal={codeModalControl.onClose}
                isOpen={codeModalControl.isOpen}
                handleCreate={onCreateCode}
            />
            <ConfirmModal
                isOpen={confirmModalControl.isOpen}
                message="Are you sure you want to remove this code?"
                onCancel={confirmModalControl.onClose}
                onClose={confirmModalControl.onClose}
                onConfirm={removeCode}
            />
        </Box>
    );
}
